import React from "react"
import config from "../../common/configuration"
import { useTranslation } from "react-i18next"

const OnSymbol = () => {
  const { t } = useTranslation()
  return <div style={config.form.switch.onSymbol}>{
    t("global:yes")}</div>
}
export default OnSymbol
